/**
 * TrustMatchBoundary (AJIP-16.02.007 · WS20)
 * Validation interfaces only per Founder Ruling B4.
 * NO implementation. NO provider connection. NO observability.
 * NO eligibility/activation/progression/completion authority.
 */
import { TrustMatchBoundaryError } from './BuyerJourneyErrors';

const TRUST_PROVIDER_METHODS = Object.freeze(['recommendSuppliers', 'describeRecommendation']);
const MATCH_PROVIDER_METHODS = Object.freeze(['recommendMatches', 'describeMatchRecommendation']);

const assertTrustRecommendationProvider = (candidate) => {
  if (!candidate || typeof candidate !== 'object') {
    throw new TrustMatchBoundaryError('TrustRecommendationProvider: candidate must be non-null object');
  }
  for (const m of TRUST_PROVIDER_METHODS) {
    if (typeof candidate[m] !== 'function') {
      throw new TrustMatchBoundaryError(`TrustRecommendationProvider: missing method '${m}'`);
    }
  }
  return true;
};

const assertMatchRecommendationProvider = (candidate) => {
  if (!candidate || typeof candidate !== 'object') {
    throw new TrustMatchBoundaryError('MatchRecommendationProvider: candidate must be non-null object');
  }
  for (const m of MATCH_PROVIDER_METHODS) {
    if (typeof candidate[m] !== 'function') {
      throw new TrustMatchBoundaryError(`MatchRecommendationProvider: missing method '${m}'`);
    }
  }
  return true;
};

// Governance reminder — enforced at runtime by absence of any activation
// authority in this file. Recommendations are non-authoritative metadata.
const RECOMMENDATION_GOVERNANCE = Object.freeze({
  ai_may: 'recommend',
  ai_shall_never: 'determine|activate|complete|progress',
});

export {
  TRUST_PROVIDER_METHODS, MATCH_PROVIDER_METHODS,
  assertTrustRecommendationProvider, assertMatchRecommendationProvider,
  RECOMMENDATION_GOVERNANCE,
};
